import React from 'react';
import AffiliateLink from './AffiliateLink';

const AddToCartButton = ({ className = '' }) => {
  return (
    <AffiliateLink className={`inline-block ${className}`}>
      <div className="relative">
        {/* Green gradient button matching original */}
        <div className="bg-gradient-to-b from-[#7cb83d] via-[#5a9a1f] to-[#4a8519] hover:from-[#8cc94d] hover:via-[#6aaa2f] hover:to-[#5a9529] text-white font-bold py-4 px-16 rounded-lg shadow-lg transform hover:scale-105 transition-all duration-200 text-center border-2 border-[#4a7a15]">
          <span className="text-2xl font-bold drop-shadow-md">Add To Cart</span>
        </div>
      </div>
    </AffiliateLink>
  );
};

export default AddToCartButton;